"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityFinalNegotiationTaxMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_final_negotiation_entity_1 = require("./opportunity-final-negotiation.entity");
let OpportunityFinalNegotiationTaxMap = class OpportunityFinalNegotiationTaxMap {
};
exports.OpportunityFinalNegotiationTaxMap = OpportunityFinalNegotiationTaxMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationTaxMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_final_negotiation_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationTaxMap.prototype, "opportunityFinalNegotiationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "tax", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiationTaxMap.prototype, "tax", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "tax_value", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiationTaxMap.prototype, "taxValue", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_final_negotiation_entity_1.OpportunityFinalNegotiation, (neg) => neg.taxMaps, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_final_negotiation_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiationTaxMap.prototype, "finalNegotiation", void 0);
exports.OpportunityFinalNegotiationTaxMap = OpportunityFinalNegotiationTaxMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_final_negotiation_tax_map")
], OpportunityFinalNegotiationTaxMap);
